module.exports = __webpack_public_path__ + "static/Vazir-Bold-59481f57f768c5ab917aa07737c3eca8.ttf";